import { user } from 'elbuild-ui-lib-core';
import { Icons } from 'toolbandi-ui-lib';
import { Injectable } from '@angular/core';

export interface NavigationItem {
	id: string;
	title: string;
	type: 'item' | 'collapse' | 'group';
	translate?: string;
	icon?: string;
	hidden?: boolean;
	url?: string;
	classes?: string;
	exactMatch?: boolean;
	external?: boolean;
	target?: boolean;
	breadcrumbs?: boolean;
	function?: any;
	badge?: {
		title?: string;
		type?: string;
	};
	children?: Navigation[];
	types?: string[];
	section?: string;
}

export interface Navigation extends NavigationItem {
	children?: NavigationItem[];
}

const NavigationItems = [
	{
		id: 'bandi',
		title: 'bandi',
		type: 'group',
		icon: 'feather icon-align-left',
		children: [
			{
				id: 'dashboard',
				title: 'Dashboard',
				type: 'item',
				url: '/dashboard',
				classes: 'nav-item',
				icon: Icons.DASHBOARD
			},
			{
				id: 'companies',
				title: 'Aziende',
				type: 'item',
				url: '/company',
				classes: 'nav-item',
				icon: Icons.COMPANY,
				types: ['admin'],
				section: 'companies.section'
			},
			{
				id: 'consultants',
				title: 'Consulenti',
				type: 'item',
				url: '/consultant',
				classes: 'nav-item',
				icon: Icons.CONSULTANT,
				types: ['admin'],
				section: 'admin.consultants.section'
			},
			{
				id: 'employees',
				title: 'Dipendenti',
				type: 'item',
				url: '/employee',
				classes: 'nav-item',
				icon: Icons.EMPLOYEE,
				section: 'employees.section'
			},
			{
				id: 'owners',
				title: 'Responsabili',
				type: 'item',
				url: '/owner',
				classes: 'nav-item',
				icon: Icons.OWNER,
				types: ['company'],
				section: 'company.owners.section'
			},
			{
				id: 'buildings',
				title: 'Edifici',
				type: 'item',
				url: '/building',
				classes: 'nav-item',
				icon: Icons.BUILDING,
				types: ['company'],
				section: 'company.buildings.section'
			},
			{
				id: 'tools',
				title: 'Strumentazione',
				type: 'item',
				url: '/tool',
				classes: 'nav-item',
				icon: Icons.TOOL,
				types: ['company'],
				section: 'company.tools.section'
			},
			{
				id: 'document',
				title: 'Documenti',
				type: 'item',
				url: '/document',
				classes: 'nav-item',
				icon: Icons.DOCUMENT,
				types: ['company'],
				section: 'company.documents.section'
			}

		]
	},
	{
		id: 'admin',
		title: 'Admin',
		type: 'group',
		icon: 'feather icon-align-left',
		children: [

			{

				id: 'users',
				title: 'Utenti',
				type: 'item',
				url: '/user',
				classes: 'nav-item',
				icon: Icons.USERS,
				types: ['company'],
			},
			{
				id: 'useraccess',
				title: 'Accessi',
				type: 'collapse',
				icon: 'feather icon-users',
				section: 'users.section',
				types: ['admin'],
				children: [
					{
						id: 'users',
						title: 'Utenti',
						type: 'item',
						url: '/user',
						classes: 'nav-item'
					}, {
						id: 'ruoli',
						title: 'Ruoli e Feature',
						type: 'item',
						url: '/rolefeatures',
						classes: 'nav-item'

					}]
			},
			{
				id: 'profile',
				title: 'Profilo',
				type: 'item',
				url: '/profile',
				classes: 'nav-item',
				icon: Icons.PROFILE,
				types: ['company']
			},
			{
				id: 'doclibrary',
				title: 'Libreria Documenti',
				type: 'item',
				url: '/doclibrary',
				classes: 'nav-item',
				icon: Icons.DOCLIBRARY,
				types: ['admin'],
				section: 'admin.doclibrary.section'

			},
			{
				id: 'doctemplate',
				title: 'Template',
				type: 'item',
				url: '/doctemplate',
				classes: 'nav-item',
				icon: Icons.DOCUMENT,
				types: ['admin'],
				section: 'admin.doctemplates.section'
			},
			{
				id: 'tenders',
				title: 'Bandi',
				type: 'item',
				url: '/tender',
				classes: 'nav-item',
				icon: Icons.TENDER,
				types: ['admin'],
				section: 'admin.tenders.section'
			},

			{
				id: 'projects',
				title: 'Progetti',
				type: 'item',
				url: '/project',
				classes: 'nav-item',
				icon: Icons.PROJECT,
				types: ['admin', 'company'],
				section: 'projects.section'
			},
			{
				id: 'list',
				title: 'Liste',
				type: 'item',
				url: '/list',
				classes: 'nav-item',
				icon: Icons.LISTS,
				types: ['admin'],
				section: 'admin.list.section'
			}
		]
	},
	{
		id: 'config',
		title: 'Configurazione',
		type: 'group',
		section: 'admin.config.section',
		types: ['admin'],
		children: [
			{
				id: 'conf',
				title: 'System',
				type: 'item',
				url: '/conf',
				classes: 'nav-item',
				icon: Icons.SYSTEM,
				types: ['admin']
			},
			{
				id: 'advanced',
				title: 'Avanzate',
				type: 'item',
				url: '/advanced',
				classes: 'nav-item',
				icon: Icons.ADVANCED,
				types: ['admin']
			}
		]
	}
];

@Injectable()
export class NavigationItem {
	public get() {
		return NavigationItems;
	}
}
